
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 21.25h-2.5m-20 0h2.5M23.75 20V7.5H6.25V20m17.5 0H6.25m17.5 0v1.25M6.25 20v1.25m17.5 0H6.25","stroke":"#ABAFB5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    